import { useState } from "react";

export default function DevToolsPage({ t }) {
    const [ping, setPing] = useState(null);
    const [running, setRunning] = useState(false);

    const runPing = () => {
        setRunning(true); setPing(null);
        setTimeout(() => { setPing(Math.floor(Math.random() * 30) + 8); setRunning(false); }, 800);
    };

    const systemStatus = [
        { label: "API Server", status: "online", latency: "12ms" },
        { label: "Database (Railway)", status: "online", latency: "28ms" },
        { label: "Map Service", status: "online", latency: "45ms" },
        { label: "Auth Service", status: "online", latency: "9ms" },
        { label: "Storage (GeoJSON)", status: "warning", latency: "120ms" },
    ];

    const dbTables = [
        { table: "User Info", icon: "👤", color: "#2a9d8f", fields: ["user_id (PK)", "name", "email", "phone", "account_type", "created_at"] },
        { table: "Business", icon: "🏪", color: "#1a3a5c", fields: ["business_id (PK)", "email", "company", "branch_id", "branch_location", "password_hash"] },
        { table: "Map", icon: "🗺️", color: "#e63946", fields: ["map_id (PK)", "shop_id (FK)", "product_id (FK)", "area_id", "geojson_data", "aruco_tag_id"] },
    ];

    const testTools = [
        { icon: "🗄️", label: "資料庫連線測試", sub: "Railway PostgreSQL" },
        { icon: "🗺️", label: "GeoJSON 解析測試", sub: "Map Service" },
        { icon: "🔑", label: "Auth Token 驗證", sub: "JWT Service" },
        { icon: "📤", label: "CSV 上傳壓力測試", sub: "File Parser" },
    ];

    return (
        <div style={{ padding: 32 }}>
            <h2 style={{ fontSize: 22, fontWeight: 700, color: t.text, margin: "0 0 8px" }}>🛠️ 系統測試工具</h2>
            <p style={{ color: t.textFaint, fontSize: 13, margin: "0 0 28px" }}>Developer Account 專屬 · A-EYE System Testing</p>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>
                {/* System Status */}
                <div style={{ background: t.surface, borderRadius: 12, padding: 20, border: `1px solid ${t.border}` }}>
                    <h3 style={{ color: t.text, fontSize: 15, fontWeight: 700, margin: "0 0 16px" }}>🟢 系統狀態監控</h3>
                    {systemStatus.map((s) => (
                        <div key={s.label} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 0", borderBottom: `1px solid ${t.border}` }}>
                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                <span style={{ fontSize: 10, color: s.status === "online" ? t.success : "#f59e0b" }}>●</span>
                                <span style={{ color: t.text, fontSize: 13 }}>{s.label}</span>
                            </div>
                            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                                <span style={{ color: t.textFaint, fontSize: 12, fontFamily: "monospace" }}>{s.latency}</span>
                                <span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 20, fontWeight: 700, background: s.status === "online" ? `${t.success}22` : "#f59e0b22", color: s.status === "online" ? t.success : "#f59e0b" }}>
                                    {s.status === "online" ? "正常" : "警告"}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Testing Tools */}
                <div style={{ background: t.surface, borderRadius: 12, padding: 20, border: `1px solid ${t.border}` }}>
                    <h3 style={{ color: t.text, fontSize: 15, fontWeight: 700, margin: "0 0 16px" }}>⚡ 測試工具</h3>
                    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                        {/* Ping */}
                        <div style={{ padding: "14px 16px", background: t.inputBg, borderRadius: 10, border: `1px solid ${t.border}` }}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                                <span style={{ color: t.text, fontSize: 13, fontWeight: 600 }}>🏓 API Ping 測試</span>
                                <button onClick={runPing} disabled={running}
                                    style={{ padding: "6px 14px", background: t.accent, border: "none", color: "white", borderRadius: 6, cursor: running ? "not-allowed" : "pointer", fontSize: 12, opacity: running ? 0.6 : 1 }}>
                                    {running ? "測試中…" : "執行 Ping"}
                                </button>
                            </div>
                            {ping !== null && <p style={{ color: t.success, fontSize: 13, fontFamily: "monospace", margin: 0 }}>✓ 回應時間：{ping}ms — 狀態正常</p>}
                            {running && <p style={{ color: t.textFaint, fontSize: 13, margin: 0 }}>⏳ 正在連接伺服器…</p>}
                        </div>
                        {/* Other Tools */}
                        {testTools.map((tool) => (
                            <div key={tool.label} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 16px", background: t.inputBg, borderRadius: 10, border: `1px solid ${t.border}` }}>
                                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                    <span style={{ fontSize: 18 }}>{tool.icon}</span>
                                    <div>
                                        <p style={{ color: t.text, fontSize: 13, fontWeight: 600, margin: 0 }}>{tool.label}</p>
                                        <p style={{ color: t.textFaint, fontSize: 11, margin: 0 }}>{tool.sub}</p>
                                    </div>
                                </div>
                                <button style={{ padding: "5px 12px", background: "transparent", border: `1px solid ${t.border}`, color: t.textMuted, borderRadius: 6, cursor: "pointer", fontSize: 12 }}>執行</button>
                            </div>
                        ))}
                    </div>
                </div>

                {/* DB Schema */}
                <div style={{ background: t.surface, borderRadius: 12, padding: 20, border: `1px solid ${t.border}`, gridColumn: "1 / -1" }}>
                    <h3 style={{ color: t.text, fontSize: 15, fontWeight: 700, margin: "0 0 16px" }}>🗄️ Database 結構 (Railway)</h3>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 12 }}>
                        {dbTables.map((db) => (
                            <div key={db.table} style={{ background: t.inputBg, borderRadius: 10, overflow: "hidden", border: `1px solid ${db.color}44` }}>
                                <div style={{ padding: "10px 14px", background: `${db.color}18`, display: "flex", alignItems: "center", gap: 8 }}>
                                    <span style={{ fontSize: 16 }}>{db.icon}</span>
                                    <span style={{ color: t.text, fontSize: 14, fontWeight: 700 }}>{db.table}</span>
                                </div>
                                <div style={{ padding: "10px 14px" }}>
                                    {db.fields.map((f) => (
                                        <div key={f} style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 5 }}>
                                            <div style={{ width: 5, height: 5, borderRadius: "50%", background: db.color, flexShrink: 0 }} />
                                            <code style={{ color: t.textMuted, fontSize: 11 }}>{f}</code>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}